import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TagDto } from '@picflow/types';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { OnGetData } from 'src/app/services/dialog.service';
import { ToastService } from 'src/app/services/toast.service';
import { InputFieldComponent } from 'src/app/shared-extra/components/input-field/input-field.component';
import { SvgComponent } from 'src/app/shared/components/svg/svg.component';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { TagService } from 'src/app/tag.service';

@Component({
  selector: 'app-edit-tag-dialog',
  standalone: true,
  imports: [CommonModule, SvgComponent, ButtonDirective, FormsModule, ReactiveFormsModule, InputFieldComponent],
  templateUrl: './edit-tag-dialog.component.html',
  styleUrls: ['./edit-tag-dialog.component.scss'],
})
export class EditTagDialogComponent implements OnGetData {
  dialogName = 'edit-tag';
  close: (tag: 'deleted' | null) => void;
  tag: TagDto;
  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
  });

  dialogOptions(): DialogOptions {
    return { hasSmallBottomPart: true };
  }

  constructor(private tagService: TagService, private toats: ToastService) {}

  onGetData(data: { tag: TagDto }, close: () => void) {
    this.tag = data.tag;
    this.close = close;
    this.form.setValue({ name: this.tag.name });
  }

  save() {
    if (!this.form.valid) return;
    return this.tagService.updateTag(this.tag.id, this.tag.name, this.tag.category).subscribe(() => {
      this.toats.add('Tag updated', 'success');
      this.close(null);
    });
  }

  deleteTag() {
    return this.tagService.deleteTag(this.tag.id).subscribe(() => {
      this.toats.add('Tag deleted', 'success');
      this.close('deleted');
    });
  }
}
